export const validateInputLabelAccessibility = (componentName, label, ariaLabel) => {
    if (!label && !ariaLabel) {
        console.warn(`${componentName}: For accessibility, a label or aria-label property must be sent.`);
    }
};
export const getPlaceholder = (placeholder, hasStartAdornment) => {
    if (placeholder) {
        return placeholder;
    }
    if (hasStartAdornment) {
        return '';
    }
    return ' ';
};
export const getDateAtStartOfDay = (date) => {
    return new Date(new Date(date).setHours(0, 0, 0, 0));
};
export const getDateAtEndOfDay = (date) => {
    return new Date(new Date(date).setHours(23, 59, 59, 999));
};
